<div class="SpectrumHeaderContainer">
  <app-header></app-header>
  <app-filter  *ngIf="(filterData$ | async) as filterData"  [filterData]="filterData"></app-filter>
</div>
<div class="Wrap">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
